import codeMessages from '../../mixins/code_messages.js'

const state = () => ({

})

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {
  showPreset (state, payload) {
    const messages = []
    const codigo = payload.codigo
    const tipo = payload.tipo
    if (typeof codeMessages[codigo] !== 'undefined') {
      messages.push(codeMessages[codigo])
    } else {
      console.log('El código de error ' + "'" + codigo + "'" + ' no está definido')
    }
    for (const message of messages) {
      this._vm.$toast[tipo](message, { position: 'bottom-right' })
    }
  },
  show (state, payload) {
    const tipo = payload.tipo
    const messages = payload.messages
    let position = 'bottom-right'
    if (typeof payload.position !== 'undefined') {
      position = payload.position
    }
     for (const message in messages) {
      this._vm.$toast[tipo](`${messages[message]}`, { position: position })
    }
  },
}
// tipos -> success", "error", "default", "info" and "warning"
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
